import { Alert, Linking } from 'react-native';
import * as Location from 'expo-location';
import { CLEAR_LOCATION, UPDATE_LOCATION } from '@reduxLocal/actions/types';
import { useDispatch } from 'react-redux';

const handleGetLocation = async (dispatch, selector) => {
  if (selector && selector.coords) {
    return selector;
  }
  try {
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      throw new Error('Permission to access location was denied');
    }

    let location = await Location.getCurrentPositionAsync({});
    location = { ...location, timestamp: Date.now() };
    dispatch({ type: UPDATE_LOCATION, payload: location });
    return location;
  } catch (error) {
    console.error(error);
    Alert.alert(
      'Permission to access location was denied',
      'Please enable location services in your settings to continue',
      [
        {
          text: 'Cancel',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        { text: 'Settings', onPress: () => Linking.openSettings() },
      ]
    );
    throw error;
  }
};

const refreshLocation = async (dispatch) => {
  dispatch({type: CLEAR_LOCATION});
  try {
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      throw new Error('Permission to access location was denied');
    }

    let location = await Location.getCurrentPositionAsync({});
    location = { ...location, timestamp: Date.now() };
    dispatch({ type: UPDATE_LOCATION, payload: location });
    return location;
  } catch (error) {
    console.error(error);
    Alert.alert(
      'Permission to access location was denied',
      'Please enable location services in your settings to continue',
      [
        {
          text: 'Cancel',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        { text: 'Settings', onPress: () => Linking.openSettings() },
      ]
    );
    throw error;
  }
}

export { handleGetLocation, refreshLocation };
